import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const hiddenMarketStateSelector = createSelector(betslipSelector, (state) => state.hiddenMarket);
export const hasPlacedFirstBetSelector = createSelector(hiddenMarketStateSelector, (state) => state.hasPlacedFirstBet);
